const typeGroupPublisher = {
  ENABLE: 1,
  DISABLE: 0,
};

const getTypeGroupPublisherPersianName = () => {
  let data = {};
  data[typeGroupPublisher.ENABLE] = "فعال";
  data[typeGroupPublisher.DISABLE] = "غیرفعال";

  return data;
};

export default {
  typeGroupPublisher,
  getTypeGroupPublisherPersianName,
};
